module.exports = __webpack_public_path__ + "static/woodframe_1920-dd8b5a9b46f60a721ca51ffd45c10aea.jpg";